import { useI18nContext } from "@i18n/i18n-react";
import { T } from "@i18n/T";
import { startCase } from "es-toolkit";
import { useFragment } from "react-relay";
import { graphql } from "relay-runtime";
import { InvitationHeaderFragment$key } from "./__generated__/InvitationHeaderFragment.graphql";

const fragment = graphql`
	fragment InvitationHeaderFragment on Invitation {
		email
		role @required(action: THROW)
		inviterName
		organizationName
	}
`;

type InvitationHeaderProps = {
	invitation: InvitationHeaderFragment$key;
};

export const InvitationHeader = (props: InvitationHeaderProps) => {
	const LL = useI18nContext().LL.auth;
	const { organizationName, inviterName, role } = useFragment(fragment, props.invitation);

	return (
		<header className="w-full border-b border-green-200 bg-green-100/50 py-3 px-4  sm:px-6">
			<div className="container mx-auto flex items-center justify-center text-center">
				<p className="text-sm text-green-900">
					<T>{LL.INVITATION_HEADER_TEXT({ organization: organizationName, inviter: inviterName, role: startCase(role) })}</T>
				</p>
			</div>
		</header>
	);
};
